import styled from 'styled-components';
// import { isConstruction } from 'config';

const isConstruction = true;

export const DataTable = styled.table`
  width: 100%;
  border: ${({ theme }) =>
    isConstruction ? `solid 1px ${theme.colors.grey3}` : '0'};
  border-collapse: ${isConstruction ? 'collapse' : 'separate'};
  border-spacing: ${isConstruction ? '0' : '8px'};
`;

export const DataRow = styled.tr`
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.grey2};
  }

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const DataCell = styled.td`
  font-size: 16px;
  width: 50%;
  padding: ${isConstruction ? '15px 20px' : '8px 12px'};
  border-left: ${({ theme }) =>
    isConstruction ? `solid 1px ${theme.colors.grey3}` : '0'};
  border-right: ${({ theme }) =>
    isConstruction ? `solid 1px ${theme.colors.grey3}` : '0'};

  &:first-child {
    border-left: none;
  }

  &:last-child {
    border-right: none;
  }
`;
